import React from "react";
import type { VerificationRequest } from "../ValidacionIdentidadPageNew";
import ValidacionCard from "./ValidacionCard";

interface Props {
    requests: VerificationRequest[];
    onOpenDrawer: (req: VerificationRequest) => void;
    onApprove: (id: string, name: string) => void;
}

const ValidacionGrid: React.FC<Props> = ({ requests, onOpenDrawer, onApprove }) => {
    if (requests.length === 0) {
        return (
            <div className="text-center py-20 border-2 border-dashed border-gray-200 bg-gray-50/50 rounded-xl text-gray-500 text-sm">
                No hay solicitudes que coincidan con los filtros.
            </div>
        );
    }

    return (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-[14px]">
            {requests.map(req => (
                <ValidacionCard 
                    key={req.id} 
                    req={req} 
                    onOpenDrawer={() => onOpenDrawer(req)}
                    onApprove={(e) => {
                        e.stopPropagation();
                        onApprove(req.id, req.name);
                    }}
                />
            ))}
        </div>
    );
};

export default ValidacionGrid;